// These must two lines be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client'; 
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from '@/store/store';
import './config/i18n'

const dotenv = require('dotenv');
dotenv.config();


const container = document.getElementById('root');
const root = createRoot(container); 
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

if ('serviceWorker' in navigator) {
  const swPath = process.env.NODE_ENV === 'production' 
    ? '/chatbot/sw.js' 
    : '/chatbot/sw-dev.js';

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      await navigator.serviceWorker.register(swPath, {
        scope: '/chatbot/'
      });
      console.info('Service Worker registered successfully');
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}
